// extracted by mini-css-extract-plugin
export var flowchartContainer = "_p-0";